<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>
                <div class="row-pointer" v-if="hoor_encrid === ''">
                    <v-row class="pa-4">
                        <h3>Add rebooking event</h3>
                    </v-row>
                    <v-row class="mb-6"><v-divider></v-divider></v-row>
                </div>
                <div class="row-pointer" v-else>
                    <v-row class="pa-4">
                        <h3>Update rebooking event</h3>
                    </v-row>
                    <v-row><v-divider></v-divider></v-row>
                    <v-row dense class="pl-4 mt-6">
                        <v-col cols="4">Registered by</v-col>
                        <v-col cols="4">{{ gebr_naam }}</v-col>
                    </v-row>
                    <v-row dense class="pl-4 mt-0">
                        <v-col cols="4">Registration date/time</v-col>
                        <v-col cols="4">{{ $moment(hoor_dt).format("DD-MM-YYYY HH:mm") }}</v-col>
                    </v-row>
                    <v-row><v-divider></v-divider></v-row>
                </div>

                <v-row dense class="pl-4 mt-8">
                    <v-col cols="4">
                        <select_status :selected_eventstatus="omst_code" label="Status" field="omst_code" @updateData="updateData" :disabled="isClosed" />
                    </v-col>
                </v-row>

                <v-row dense class="pl-4 pr-6">
                    <v-col cols=12>
                        <v-form v-model="hoor_valid">
                            <v-textarea v-model="hoor_oms" rows="4" required label="Rebooking event text" :rules="descriptionRules">{{ hoor_oms }}</v-textarea>
                        </v-form>
                    </v-col>
                </v-row>

                <v-card fluid flat class="mt-0 pl-4 mb-4 pr-6">
                    <homb_links :links="hoor_urls" @updateData="updateData" />
                </v-card>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" small :disabled="!hoor_valid" v-on:click="addUpdHoor()">Save</v-btn>
                    <v-btn color="primary" small v-on:click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>

import select_status from '@/components/huov/homb/ui/select_eventstatus.vue';
import homb_links from '@/components/huov/ui/hokl_hosm_links.vue';

export default {
    props: {
        homb_encrid: String
    },
    components: {
        select_status,
        homb_links,
    },
    data() {
        return {
            dialog: false,
            hoor_valid: false,

            hoor_encrid: '',

            hoor_dt: null,
            hoor_oms: '',
            omst_code: '',
            gebr_code: '',
            gebr_naam: '',
            hoor_urls: [],

            descriptionRules: [
                v => !!v || "A description / value is required"
            ],
            isClosed: false
        }
    },

    methods: {
        open(hoor_encrid) {
            this.hoor_encrid = hoor_encrid;            
            this.hoor_dt = null;
            this.hoor_oms = '';
            this.omst_code = 'new';
            this.gebr_code = '';
            this.gebr_naam = '';
            this.hoor_urls = [];
            if (hoor_encrid !== '') {
                this.getSingleHoor();
            } else {
                this.dialog = true;
            }
            this.isClosed = false;
        },
        getSingleHoor() {
			this.$axios
				.post("ares/json/ares/huov/homb/getHoor.p", {
					header: {
						token: this.$session.get("ARES"),
						clientSessionId: this.$session.id(),
						request: "getHoor"
					},
					getHoor: {
                        homb_encrid: this.homb_encrid,
						hoor_encrid: this.hoor_encrid
					}
				})
				.then(res => {
					if (res.data.error) {
						console.log(res.data.error);
						this.dialog = false; // do not show dialog
					} else {
                        // getHoor returns an array, with one hoor.
                        let hoor = res.data.getHoor[0];

                        this.hoor_dt = hoor.hoor_dt;
                        this.hoor_oms = hoor.hoor_oms;
                        this.omst_code = hoor.omst_code;
                        this.gebr_code = hoor.gebr_code;
                        this.gebr_naam = hoor.gebr_naam;
                        this.hoor_urls = hoor.hoor_urls;
                        this.isClosed = (hoor.omst_code === 'closed');
						// now show dialog
						this.dialog = true;
					}
				});
		},
        updateData(data) {
            // console.log('update data add_upd_hoor', data);
            this[data.field] = data.value;
        },
        addUpdHoor() {
            let add_upd_data = {
                homb_encrid: this.homb_encrid,
                hoor_encrid: this.hoor_encrid,
                gebr_code: this.gebr_code,
                hoor_text: this.hoor_oms,
                hoor_omst: this.omst_code,
                hoor_urls: this.hoor_urls
            }
            if (this.hoor_encrid === "") {
                this.$axios.post("ares/json/ares/huov/homb/addHoor.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHoor"
                    },
                    addHoor: add_upd_data
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        // laten we hopen dat dit nooit gebeurt, we zetten de gebruiker vast in dit dialog met een melding of iets
                    } else {
                        this.closeDialog();                       
                    }
                }).finally();
            } else {
                this.$axios.post("ares/json/ares/huov/homb/updHoor.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHoor"
                    },
                    updHoor: add_upd_data
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        // laten we hopen dat dit nooit gebeurt, we zetten de gebruiker vast in dit dialog met een melding of iets
                    } else {
                        this.closeDialog();                       
                    }
                }).finally();
            }
        },
		closeDialog(){
            this.$emit("updateData", "refresh");
			this.dialog = false;
		}
    }
}
</script>

<style scoped>
    .row-pointer {
        cursor: default;
    }
</style>